import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CourseAreaListComponent } from '@app/components/course-areas/list/course-area-list/course-area-list.component';
import { ErrorService, isPausedAccess } from '@app/services/error.service';
import { Observable } from 'rxjs/Observable';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private errorService: ErrorService) {}

  canDeactivate(component: CanComponentDeactivate) {
    if (component instanceof CourseAreaListComponent && !sessionStorage.getItem('token')) {
      return true;
    }

    if (!!this.errorService.error && isPausedAccess(this.errorService.error.code)) {
      return true;
    }

    return component.canDeactivate ? component.canDeactivate() : true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guards/can-deactivate-guard.service.ts